import FactoryComponents from '../../../../../factory/components/FactoryComponents.js';
import ProcessDangerTaskTroubleshoot from '../processDangerTask/ProcessDangerTaskTroubleshoot.vue';
import {getRiskPoint} from '@/api/processManager'

const root = {}
export default root
root.components = {ProcessDangerTaskTroubleshoot};
root.name = 'processDangerTask';
root.data = {

    //当前显示列表数据还是新建或者编辑
    thisOperaModel: 0,

    planList: [],
    thisDBname:"",
    dangerTaskTableTitle1: [
        {
            title: '编号',
            slot: 'taskNum',
            width: 150,
        },
        {
            title: '任务名称',
            key: 'planName'
        },
        {
            title: '来源',
            slot: 'type'
        },
        {
            title: '排查人姓名',
            key: 'troubleshootEmployeeName',
        },
       /* {
            title: '巡检点名称',
            key: 'hiddendangerName',
            width: 180,
            tooltip: true,
            theme: "light"
        },*/
        {
            title: '计划开始时间',
            slot: 'planStartTime',
            // tooltip: true
        },
        {
            title: '计划完成时间',
            slot: 'planEndTime',
            // tooltip: true
        },
        {
            title: '实际开始时间',
            slot: 'startTime',
            // tooltip: true
        },
        {
            title: '实际完成时间',
            slot: 'endTime',
            // tooltip: true
        },
        {
            title: '排查人',
            key: 'troubleshootEmployeeName',
        },
        {
            title: '状态',
            slot: 'status',
        },
        {
            title: '数据状态',
            slot: 'departmentId',
        },
        {
            title: '操作',
            slot: 'action',
            width: 200,
        }
    ],
    dangerTaskTableTitle: [
        {
            title: '编号',
            slot: 'taskNum',
            width: 150,
        },
        {
            title: '任务名称',
            key: 'planName'
        },
        {
            title: '来源',
            slot: 'type'
        },
        {
            title: '排查人姓名',
            key: 'troubleshootEmployeeName',
        },
        /* {
             title: '巡检点名称',
             key: 'hiddendangerName',
             width: 180,
             tooltip: true,
             theme: "light"
         },*/
        {
            title: '计划开始时间',
            slot: 'planStartTime',
            // tooltip: true
        },
        {
            title: '计划完成时间',
            slot: 'planEndTime',
            // tooltip: true
        },
        {
            title: '实际开始时间',
            slot: 'startTime',
            // tooltip: true
        },
        {
            title: '实际完成时间',
            slot: 'endTime',
            // tooltip: true
        },
        {
            title: '排查人',
            key: 'troubleshootEmployeeName',
        },
        {
            title: '状态',
            slot: 'status',
        },
        {
            title: '操作',
            slot: 'action',
            width: 200,
        }
    ],
    //检查标准
    dangerTaskCheckTableTitle: [
        {
            title: '编号',
            key: 'checkNo'
        },
        {
            title: '检查项目',
            key: 'checkProject'
        },
        {
            title: '检查标准',
            key: 'checkStand',
        },
        {
            title: '检查方法',
            key: 'checkMethod',
        }
    ],
    //检查标准
    dangerTaskCheckData: [],


    dangerTaskData: {
        //模糊查询条件
        selectCondition: {
            //查询名称
            name: '',
            //开始时间
            startTime: "",
            //结束时间
            endTime: '',
            //计划开始时间
            planStartTime: '',
            //计划结束时间
            planEndTime: '',
            //状态
            status: "",


        },
        //总页数
        total: 1,
        //每页多少行
        limit: 10,
        //当前页数
        thisPage: 1,
        //数据
        data: [],
        //操作缓存数据
        cacheData: {},
        //排查计划
        dangerPlanData: [],
        //人员数据
        eployeeData: [],
        //点击保存时的操作
        http: null,

    },

    //排查任务
    troubleshootOpera: {
        //是否显示排查任务排查界面
        showOpera: false,
        //当前排查任务数据
        cacheData: {},
        //是否是查看模式
        seeModel: false,
    },

    //抽屉的背景颜色
    drawerStyles: {
        backgroundColor: "#f7f7f7",
    },

    // 下拉框风险点的数组
    riskPointList: [],
},
    root.filters = {
        // filter1(val) {
        //   if(val) {
        // 		let arr = JSON.parse(val)
        // 		return arr.join(',')
        // 	} else {
        // 		return ''
        // 	}
        // },
        // filter2(val) {
        // 	let str = JSON.parse(val).join(',')
        // 	return str.substring(0,16) + '...'
        // }
    }
root.methods = {
    // 表格上风险点的显示
    // checkPointIds(riskPointIds) {
    // 	if (!riskPointIds) {
    // 		return false
    // 	} else {
    // 		let str = JSON.parse(riskPointIds).join(',')
    // 		if(str.length > 16) {
    // 			return true
    // 		} else {
    // 			return false
    // 		}
    // 	}
    // },

    // 选择风险点时的事件
    riskPointChange(val) {
        // console.log(val)
        let arr = []
        for (let i in val) {
            for (let j in this.riskPointList) {
                if (val[i] === this.riskPointList[j].riskName) {
                    arr.push(this.riskPointList[j].id)
                }
            }
        }
        this.dangerTaskData.cacheData.riskClassificationIds = arr.join(',')
    },
    typeChoose: function (data){
        this.getDangerTaskList(1);
    },
    getDangerTaskList(page) {
        this.dangerTaskData.thisPage = page;
        const that = this;
        const data = {...this.dangerTaskData.selectCondition};
        data.limit = this.dangerTaskData.limit;
        data.curPage = page ? page : this.dangerTaskData.thisPage;
        this.componentsMoudel.startPost("/troubleshoottask/list", data, true).then(res => {
            if (res.body.data !== null) {
                let arr = res.body.data
                for (let i in arr) {
                    let hiddens = this.riskPointList.filter((item) => item.id == arr[i].hidden_id);
                    if (hiddens.length > 0) {
                        arr[i].hiddendangerName = hiddens[0].name;
                    }
                }
                that.dangerTaskData.data = arr
            } else {
                that.dangerTaskData.data = []
            }
            // that.dangerTaskData.data = res.body.data === null ? [] : res.body.data;
            that.dangerTaskData.total = res.body.cum;
        })
    },

    //获取排查任务
    getDangerTask(page) {
        this.dangerTaskData.thisPage = page;
        const that = this;
        const data = {...this.dangerTaskData.selectCondition};
        data.limit = this.dangerTaskData.limit;
        data.curPage = page ? page : this.dangerTaskData.thisPage;
        this.componentsMoudel.startPost("/troubleshoottask/list_all", data, true).then(res => {
            if (res.body.data !== null) {
                let arr = res.body.data
                for (let i in arr) {
                    let hiddens = this.riskPointList.filter((item) => item.id == arr[i].hidden_id);
                    if (hiddens.length > 0) {
                        arr[i].hiddendangerName = hiddens[0].name;
                    }
                }
                that.dangerTaskData.data = arr
            } else {
                that.dangerTaskData.data = []
            }
            // that.dangerTaskData.data = res.body.data === null ? [] : res.body.data;
            that.dangerTaskData.total = res.body.cum;
        })
    },

    //新增任务
    addDangerTask: function () {
        const that = this;
        const data = {type: 2, ...this.dangerTaskData.cacheData};
        data.jointEmployeeIds = JSON.stringify(data.jointEmployeeIds);
        data.creator = this.dangerTaskData.cacheData.creator
        data.isDefend = this.dangerTaskData.cacheData.isDefend
        data.isTest = this.dangerTaskData.cacheData.isTest
        data.hdcheckplanId = this.dangerTaskData.cacheData.hdcheckplanId
        this.componentsMoudel.startPost("/troubleshoottask/save", data, true).then(res => {
            that.getDangerTask(that.dangerTaskData.thisPage);
            that.returnDataTableList();
        })
    },

    //更新任务
    updateDangerTask: function () {
        const that = this;
        const data = {};
        data.planId = this.dangerTaskData.cacheData.planId;
        data.id = this.dangerTaskData.cacheData.id;
        data.planName = this.dangerTaskData.cacheData.planName;
        data.troubleshootEmployeeId = this.dangerTaskData.cacheData.troubleshootEmployeeId;
        data.planStartTime = this.dangerTaskData.cacheData.planStartTime;
        data.planEndTime = this.dangerTaskData.cacheData.planEndTime;
        data.jointEmployeeIds = JSON.stringify(this.dangerTaskData.cacheData.jointEmployeeIds);
        data.riskPointIds = JSON.stringify(this.dangerTaskData.cacheData.riskPointIds)
        data.riskClassificationIds = this.dangerTaskData.cacheData.riskClassificationIds
        data.isTest=this.dangerTaskData.cacheData.isTest
        data.isDefend = this.dangerTaskData.cacheData.isDefend
        data.creator = this.dangerTaskData.cacheData.creator
        console.log(this.dangerTaskData.cacheData)
        this.componentsMoudel.startPost("/troubleshoottask/update", data, true).then(res => {
            that.getDangerTask(that.dangerTaskData.thisPage);
            that.returnDataTableList();
        })
    },
    //上报管委平台
    uploadDangerTask: function (data) {
        const that = this;
        this.componentsMoudel.startPost('/troubleshoottask/upload/' + data.id, data, true).then(res => {
            if (this.dangerTaskData.data.length <= 1 && this.dangerTaskData.thisPage > 1) {
                this.dangerTaskData.thisPage -= 1
            }
            that.getDangerTask(that.dangerTaskData.thisPage);
            this.$message.success('上报成功')
        })
    },
    //删除隐患排查任务
    delDangerTask: function (data) {
        const that = this;
        this.componentsMoudel.startDel("/troubleshoottask/delete/" + data.id, null, true).then(res => {
            if (this.dangerTaskData.data.length <= 1 && this.dangerTaskData.thisPage > 1) {
                this.dangerTaskData.thisPage -= 1
            }
            that.getDangerTask(that.dangerTaskData.thisPage);
            this.$message.success('删除成功')
        })
    },

    //获取排查计划
    getDangerTaskPlan: function (id) {
        const that = this;
        this.componentsMoudel.startGet("/troubleshootplan/info/" + id, null, true).then(res => {
            that.dangerTaskCheckData = res.body.data.checkStandardVos;
        })
    },

    //点击新增或者编辑时的操作
    opereDangerTask: function (data, see = true) {
        this.dangerTaskData.actionType = see;
        if (data) {
            this.dangerTaskData.cacheData = {...data};
            console.log(this.dangerTaskData.cacheData)
            if (this.dangerTaskData.cacheData.jointEmployeeIds) {
                // console.log(this.dangerTaskData.cacheData.jointEmployeeIds)
                // this.dangerTaskData.cacheData.jointEmployeeIds = JSON.parse(this.dangerTaskData.cacheData.jointEmployeeIds);
                this.dangerTaskData.cacheData.jointEmployeeIds = JSON.parse(this.dangerTaskData.cacheData.jointEmployeeIds).map(v => Number(v))
            }
            if (data.riskPointIds) {
                try {
                    this.dangerTaskData.cacheData.riskPointIds = data.riskPointIds.split(',')
                } catch (err) {
                    this.dangerTaskData.cacheData.riskPointIds = []
                }
            }
            this.dangerTaskData.http = this.updateDangerTask;
            //this.getDangerTaskPlan(data.planId);
        } else {
            this.dangerTaskData.http = this.addDangerTask;
            see = false;
        }
        this.getDangerPlan();
        this.thisOperaModel = 1;
        this.dangerTaskData.seeModel = see;
    },
    //在新增或者编辑界面点击返回时的操作
    returnDataTableList: function () {
        this.dangerTaskData.cacheData = {};
        this.thisOperaModel = 0;
        this.dangerTaskCheckData = [];
    },

    //获取排查计划
    getDangerPlan: function () {
        if (this.dangerTaskData.dangerPlanData.length === 0) {
            const that = this;
            const data = {};
            data.name = "";
            data.curPage = 1;
            data.limit = 1000;
            this.componentsMoudel.startPost(this.componentsMoudel.getData('urls').getDangerPlanListAll, data, true).then(res => {
                that.dangerTaskData.dangerPlanData = res.body.data === null ? [] : res.body.data;
            })
        }
    },

    //获取人员列表
    getAllEployee: function () {
        if (this.dangerTaskData.eployeeData.length === 0) {
            const that = this;
            const data = {};
            data.curPage = 1;
            data.limit = 1000;
            this.componentsMoudel.startGet(this.componentsMoudel.getData('urls').getAllUser, data, false).then(res => {
                that.dangerTaskData.eployeeData = res.body.data;
            })
        }
    },

    //选择计划时的回调，用于初始化填充任务名称
    chooseDangerPlan: function (data) {
        this.dangerTaskData.cacheData.planName = data.label;
        this.getDangerTaskPlan(data.value);
    },

    //点击保存时的操作
    clickSave: function () {
        if (this.dangerTaskData.http !== null) {
            this.dangerTaskData.http();
        }
    },

    //状态选择点击时查询
    statusChoose: function (data) {
        this.getDangerTask(1);
    },


    //排查任务
    troubleshootTask: async function (data) {
        const res = await this.componentsMoudel.startGet("/troubleshoottask/info/" + data.id, null, true);
        this.troubleshootOpera.cacheData = res.body.data;
        this.troubleshootOpera.showOpera = true;
    },

    //排查任务回调
    troubleshootTaskCallBack: function (data) {
        this.troubleshootOpera.cacheData = {...data};
        if (data.hiddenGovernNum) {
            this.$router.push({path: "/processManager/dangerGovern", query: data})
        }
    },

    // 抽屉关闭刷新页面
    closeDrawer() {
        this.getDangerTask(this.dangerTaskData.thisPage)
    }
}
root.mounted = async function () {

    this.thisDBname = localStorage.getItem('manufacturer')
    if (this.thisDBname === "wuweiyiti240" || this.thisDBname === "wuweiyiti257"|| this.thisDBname === "wuweiyiti249"|| this.thisDBname === "wuweiyiti250"|| this.thisDBname === "wuweiyiti237") {
        this.dangerTaskTableTitle = this.dangerTaskTableTitle1
    }

    // 获取巡查点列表
    this.componentsMoudel.startGet(this.componentsMoudel.getData('urls').getDangerTypeAll).then(res => {
        this.riskPointList = res.body.data
        if (this.$route.query.taskNum) {
            this.$set(this.dangerTaskData.selectCondition, 'name', this.$route.query.taskNum)
            this.getDangerTask(1);
            this.troubleshootTask(this.dangerTaskData.data[0])
        } else {
            this.getDangerTask(1);
        }
    })

    this.getAllEployee();

}

FactoryComponents.initComponent(root);
